import { apiClient } from './client';
import type { User } from '../types';

export const authApi = {
  me: async () => {
    const res = await apiClient.get('/auth/me');
    return res.data.data.user as User & { companyMembers?: any[] };
  },

  updateProfile: async (data: { name?: string; avatar?: string }) => {
    const res = await apiClient.post('/auth/update-profile', data);
    return res.data.data.user as User;
  },

  deleteAccount: async () => {
    await apiClient.delete('/auth/account');
  },
};
